import Map from 'ol/Map';
import View from 'ol/View';
import Cluster from 'ol/source/Cluster';
import { fromLonLat, toLonLat } from 'ol/proj';
import { OSM, Vector as VectorSource, TileJSON } from 'ol/source';
import { Icon, Circle as CircleStyle, Fill, Stroke, Style, Text } from 'ol/style';
import { Point } from 'ol/geom';
import { Feature } from 'ol';
import { Tile as TileLayer, Vector as VectorLayer, VectorTile } from 'ol/layer';
import { defaults as defaultControls, Attribution } from 'ol/control';
import { DragPan, MouseWheelZoom, defaults } from 'ol/interaction';
import { platformModifierKeyOnly } from 'ol/events/condition.js';
import { createEmpty, extend, getHeight, getWidth } from 'ol/extent';
import { apply, applyStyle, applyBackground } from 'ol-mapbox-style';
// import markers from './../../../web/wp-content/themes/cler-tims-2024/map-points.json';
import { clickToCopy } from '../common';

export default mainMap => {
    console.log('mainMap');
    const filtersButton = mainMap.querySelector('.select-button');
    const popup = mainMap.querySelector('#popup');
    const popupCloseBtn = popup.querySelector('.btn-close-popup');
    const padding = 250;
    const centerFrance = [2.6768017, 46.809665];
    const centerOverseas = [2.6768017, 46.809665];
    const ww = window.innerWidth;
    const markerFilters = mainMap.querySelectorAll('.marker-filter');
    const maptilerKey = 'C5zQXUO0aC4Y3CxewOWu';
    const styleJson = `https://api.maptiler.com/maps/f3ca272c-d952-4187-b743-508cfdb69647/style.json?key=${maptilerKey}`;
    const attribution = new Attribution({
        collapsible: false,
    });
    const view = new View({
        center: fromLonLat(centerFrance),
        zoom: ww < 768 ? 5 : 6,
        // maxZoom: 18,
    });
    let map;
    let features = new Array();
    // let clickFeature;
    // let clickResolution;
    let hoverFeature;
    let clusters;
    let first = true;

    function fillAndOpenPopup(element) {
        let html = `
            <div class="popup-content-text">
        `;

        if (element.tags !== '') {
            html += `
                <ul class="tags-container">
            `;

            element.tags.forEach(tag => {
                html += `<li class="tag tag-secondary">${tag}</li>`;
            });

            html += `
                </ul>
            `;
        }

        if (element.title !== '') {
            html += `
                <div class="subtext">${element.title}</div>
            `;
        }

        if (element.text !== '') {
            html += `
                <p class="small">${element.text}</p>
            `;
        }

        if (element.contact !== '') {
            html += `
                <div class="email-container">
                    <a href="mailto:${element.contact}" class="contact">${element.contact}</a>
                    <button class="btn btn-copy"></button>
                </div>
            `;
        }

        html += `
            </div>
        `;

        if (element.ctaUrl) {
            html += `
                <div class="btns-container">
                    <a href="${element.ctaUrl}" target="_blank" class="btn btn-main primary"><span class="text">${element.ctaText}</span><span class="icon"></span></a>
                </div>
            `;
        }

        popup.querySelector('.popup-content').innerHTML = html;

        if (popup.querySelector('.btn-copy')) {
            popup.querySelector('.btn-copy').addEventListener('click', () => {
                clickToCopy(popup.querySelector('.contact').textContent);
            });
        }

        popup.classList.add('show');
    }

    function closePopup() {
        popup.classList.remove('show');
    }

    function zoom(level) {
        const view = map.getView();
        const zoom = view.getZoom();

        switch (level) {
            case 'in':
                view.setZoom(zoom + 1);
                break;
            case 'out':
                view.setZoom(zoom - 1);
                break;
            default:
                break;
        }
    }

    function clusterStyle(feature) {
        const size = feature.get('features').length;

        if (size > 1) {
            return [
                new Style({
                    image: new CircleStyle({
                        radius: 21,
                        fill: new Fill({
                            color: '#FBBA00',
                        }),
                        stroke: new Stroke({
                            width: 1,
                            color: '#FFFFFF',
                        }),
                    }),
                    text: new Text({
                        font: '15px Mulish',
                        text: size.toString(),
                        fill: new Fill({
                            color: '#1A1A1A',
                        }),
                    }),
                }),
            ];
        }

        return new Style({
            geometry: feature.get('features')[0].getGeometry(),
            image: new Icon({
                src: ParamsData.wp_theme_url + 'assets/img/marker.svg',
                anchor: [0.4, 1],
            }),
        });
    }

    function selectedFilters() {
        let value = '';

        mainMap.querySelectorAll('.marker-filter:checked').forEach((markerFilter, index) => {
            value += (index !== 0 ? ', ' : '') + markerFilter.dataset.filter;
        });

        return value;
    }

    function initMap() {
        const layer = new VectorTile({ declutter: true });

        map = new Map({
            target: 'map',
            view: view,
            controls: defaultControls({
                zoom: false,
                attribution: false,
            }).extend([attribution]),
            interactions: defaults({
                dragPan: ww < 768 ? false : true,
                mouseWheelZoom: false,
            }).extend([
                new DragPan({
                    condition: function (event) {
                        return this.getPointerCount() === 2 || platformModifierKeyOnly(event);
                    },
                }),
                new MouseWheelZoom({
                    condition: platformModifierKeyOnly,
                }),
            ]),
        });

        applyStyle(layer, styleJson);
        map.addLayer(layer);

        map.on('click', evt => {
            closePopup();

            let feature = map.forEachFeatureAtPixel(evt.pixel, feature => {
                return feature;
            });

            if (feature) {
                if (feature.values_ !== undefined) {
                    if (feature.values_.features.length === 1) {
                        fillAndOpenPopup(feature.values_.features[0].values_);

                        view.animate({
                            center: fromLonLat(feature.values_.features[0].values_.coord),
                        });
                    } else {
                        clusters.getFeatures(evt.pixel).then(clickedFeatures => {
                            if (clickedFeatures.length) {
                                const features = clickedFeatures[0].get('features');

                                if (features.length > 1) {
                                    const extent = createEmpty();

                                    features.forEach(feature => extend(extent, feature.getGeometry().getExtent()));

                                    const view = map.getView();
                                    // const resolution = map.getView().getResolution();

                                    // console.log('view.getZoom()', view.getZoom());
                                    // console.log('view.getMaxZoom()', view.getMaxZoom());
                                    // console.log('getWidth(extent)', getWidth(extent));
                                    // console.log('getHeight(extent)', getHeight(extent));
                                    // console.log('resolution', resolution);

                                    // if (view.getZoom() === view.getMaxZoom() || (getWidth(extent) < resolution && getHeight(extent) < resolution)) {
                                    //     console.log('if if');
                                    //     clickFeature = features[0];
                                    //     clickResolution = resolution;
                                    // } else {
                                    view.fit(extent, {
                                        duration: 1000,
                                        padding: [padding, padding, padding, padding],
                                    });
                                    // }
                                }
                            }
                        });
                    }
                }
            }
        });

        map.on('pointermove', event => {
            clusters.getFeatures(event.pixel).then(features => {
                if (features[0] !== hoverFeature) {
                    hoverFeature = features[0];
                    map.getTargetElement().style.cursor = hoverFeature && hoverFeature.get('features').length >= 1 ? 'pointer' : '';
                }
            });
        });
    }

    function createMarkers(filters = []) {
        features = [];

        fetch(`${ParamsData.wp_theme_url}map-points.json`, {
            method: 'GET',
            cache: 'no-store',
        })
            .then(response => response.json())
            .then(json => {
                // console.log(json);
                json.forEach(marker => {
                    let markerDisplayed = false;

                    filters.forEach(filter => {
                        if (marker.tags.includes(filter)) markerDisplayed = true;
                    });

                    if (filters.length === 0 || markerDisplayed) {
                        features.push(
                            new Feature({
                                contact: marker.contact,
                                coord: [marker.coord[0], marker.coord[1]],
                                ctaText: marker.ctaText,
                                ctaUrl: marker.ctaUrl,
                                geometry: new Point(fromLonLat([marker.coord[0], marker.coord[1]])),
                                text: marker.text,
                                title: marker.title,
                                type: 'Point',
                                tags: marker.tags,
                            }),
                        );
                    }
                });

                if (first) initMap();

                clusters = new VectorLayer({
                    source: new Cluster({
                        source: new VectorSource({
                            features: features,
                        }),
                        distance: 50,
                    }),
                    style: clusterStyle,
                });

                map.addLayer(clusters);

                first = false;
            });
    }

    function filtering(event) {
        const checkedFilters = event.target.closest('.filters-list').querySelectorAll(':checked');
        let filters = [];

        checkedFilters.forEach(filter => filters.push(filter.dataset.filter));

        map.removeLayer(clusters);

        createMarkers(filters);

        filtersButton.querySelectorAll('.text').forEach(btn => (btn.textContent = `Filter par : ${selectedFilters()}`));
    }

    function init() {
        createMarkers();
    }

    init();

    document.querySelector('#map-france').addEventListener('click', () => {
        view.animate({
            center: fromLonLat(centerFrance),
            duration: 1000,
            zoom: 6,
        });
    });

    document.querySelector('#map-overseas').addEventListener('click', () => {
        view.animate({
            center: fromLonLat(centerOverseas),
            duration: 1000,
            zoom: 1,
        });
    });

    markerFilters.forEach(markerFilter => markerFilter.addEventListener('change', filtering));
    document.querySelector('.btn-zoom-in').addEventListener('click', () => zoom('in'));
    document.querySelector('.btn-zoom-out').addEventListener('click', () => zoom('out'));

    popupCloseBtn.addEventListener('click', closePopup);
};
